// extracted by mini-css-extract-plugin
export var buttons = "cookie-notification-module--buttons--89164";
export var cookieNotification = "cookie-notification-module--cookie-notification--be0cb";
export var headline = "cookie-notification-module--headline--552ca";
export var wrapper = "cookie-notification-module--wrapper--bf128";